module.exports = __webpack_public_path__ + "img/oaFlowData168@3x.6de09df2.png";